/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/cart';
const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_ACTION = '/wine';

/**
 * Verifies if purchasing wine products is allowed
 * given the details
 * @param {object} wcEnv
 * @param {string} jwtToken
 * @param {object} payload Details to verify
 */

const verifyWine = (wcEnv, jwtToken, payload) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = `${RESOURCE_PAGE_FACADE}/${RESOURCE_PAGE_ACTION}/verify`;

    return restClient.postFacade(env, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export const verifyWineAndAvailability = (wcEnv, jwtToken, payload) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = '/availability/wineavailability';

    return restClient.postFacade(env, resourcePage, jwtToken, payload)
        .then((response) => response)
        .catch(() => ({ data: { error: 'Product is not available' } })); // For CYO products it's returning 500 for invalid zip code
};

export default verifyWine;
